import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { LimitesFundo } from 'src/app/model/limite-agente-financeiro.model';
import { LimiteService } from 'src/app/shared/services/limite.service';

@Injectable({ providedIn: 'root'})
export class LimitesFundoResolver implements Resolve<Observable<LimitesFundo>> {

    constructor(
         private limiteService: LimiteService
    ) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<LimitesFundo>  {

        return this.limiteService.getLimitesFundo();
    }
}
